import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function MaintenanceSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="maintenance" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16 reveal">
          <SectionLabel
            label={businessToolData.maintenance.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {businessToolData.maintenance.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {businessToolData.maintenance.description}
          </p>
        </div>

        <div className="reveal max-w-3xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-shield-check-line text-background-50 text-lg" />
              </div>
              <p className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                主な保守内容
              </p>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 mb-6">
              {businessToolData.maintenance.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="pt-5 border-t border-background-200/70">
              <div className="flex items-baseline gap-2 mb-3">
                <span className="text-xs font-medium text-foreground-500 font-label">
                  {businessToolData.maintenance.priceLabel}
                </span>
                <span className="text-xl md:text-2xl font-bold text-primary-600 font-heading">
                  {businessToolData.maintenance.price}
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {businessToolData.maintenance.priceNote}
              </p>
              <p className="text-xs text-foreground-600 leading-relaxed bg-background-50 rounded-md p-3 border border-background-200/50">
                <i className="ri-information-line text-secondary-500 mr-1" />
                {businessToolData.maintenance.additionalNote}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10 md:mt-12 reveal">
          <button
            onClick={scrollToContact}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            保守・運用について相談する
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}